import React from "react";
import { useHistory } from "react-router-dom";
import { CardContent, Wrapper } from "../issue/form/styles";
import BackButtom from "../../../components/backButton";
import FormFactory from "../../../components/form-factory";
import { Fields } from "./fields";
import { theme } from "../../../styles/theme";
import { IssueTypeEnum } from "../../../enums/issue-type.enum";

const IssueTypeForm: React.FC = () => {
  const history = useHistory();

  const onSubmit = (values: any): void => {
    if (!values.type) return;

    if (values.type === IssueTypeEnum.SINGLE) {
      history.push("/issue/create");
    } else if (values.type === IssueTypeEnum.RECURRENT) {
      history.push("/recurrency/create");
    }
  };

  return (
    <Wrapper>
      <BackButtom text="Emitir Nota" />

      <CardContent>
        <FormFactory
          groups={Fields()}
          onSubmit={onSubmit}
          backButton={{
            submit: "Voltar",
            submitting: "Voltando...",
            hide: true,
            onClick: () => history.goBack(),
            backgroundColor: theme.colors.darkBlue,
          }}
          button={{
            submit: "Avançar",
            submitting: "Avançando...",
            hide: false,
            backgroundColor: theme.colors.blue400,
          }}
        />
      </CardContent>
    </Wrapper>
  );
};

export default IssueTypeForm;